import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Highlight';
import create from './create';
import edit from './edit';
import list from './list';

const highlights: ResourceProps = {
  name: 'highlights',
  icon,
  options: { label: 'Destaques' },
  create,
  edit,
  list
};

export default highlights;
